const $win = $(window)
const windowWidth = $win.width()
const windowHeight = $win.height()
const enableOnRes = !!windowWidth && windowWidth > 998

var stickyScroll = function() {
	var top = $win.scrollTop()
	var $menu = $('.js-stickynav').children()

	// active items
	$menu.each(function () {
			var $el = $(this)
			var href = $el.attr("data-target")

			if (href !== undefined && href.match("#")) {
				var $target = $(href)

				var startFrom = 0
				var offset = windowHeight / 2

				if ($target.length) {
					const position = $target.offset()
					var scroll = 0

					if (position !== undefined) {
						scroll = position.top
					}

					if (top === undefined){
						return false
					}

					if (windowHeight === undefined){
						return false
					}

					if(top + windowHeight == $(document).height()) {
					 $menu.removeClass("is-active")
					 $menu.last().addClass("is-active")
					}
					else if(top < offset) {
						$menu.removeClass("is-active")
						$menu.first().addClass("is-active")
					}
					else if ( (scroll -(offset) <= top) && top > startFrom) {
						$menu.removeClass("is-active")
						$el.addClass("is-active")
					}
					else{
						$el.removeClass("is-active")
					}

				}

			}
	})
}

if(enableOnRes){
	$win.scroll(function() {
		window.requestAnimationFrame(stickyScroll)
	})
	// initial call
	stickyScroll()
}
